import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Your custom formula',
    desc: 'We assess your skin and create your personal cocktail.'
  }, {
    num: '2',
    title: 'Delivered directly (30 min)',
    desc: 'Microinjections reach the layer where real hydration lives.'
  }, {
    num: '3',
    title: 'The glow builds',
    desc: 'Visibly dewier within days. Results deepen over 3–4 sessions.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-181">
      <div className="container mx-auto px-4 md:px-6" data-id="element-182">
        <FadeIn data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-primary mb-16 md:mb-24" data-id="element-184">
            How It Works
          </h2>
        </FadeIn>

        <div className="relative max-w-5xl mx-auto" data-id="element-185">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-[1px] bg-divider z-0" data-id="element-186"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-187">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 200} className="flex flex-col items-center text-center" data-id="element-188">
                <div className="w-16 h-16 rounded-full bg-cream border border-gold text-gold flex items-center justify-center text-xl font-serif mb-6 shadow-sm" data-id="element-189">
                  {step.num}
                </div>
                <h3 className="text-xl font-serif font-medium text-primary mb-3" data-id="element-190">
                  {step.title}
                </h3>
                <p className="text-foreground/70 leading-relaxed max-w-xs" data-id="element-191">
                  {step.desc}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}